import {Component, Inject, OnInit, Optional} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FinishPoint} from '../../../../core/model/resources/finish-point';
import {MessageDialogComponent} from '../../message-dialog/message-dialog.component';

@Component({
    selector: 'app-finish-point-dialog',
    templateUrl: './finish-point-dialog.component.html',
    styleUrls: ['./finish-point-dialog.component.scss'],
    standalone: false
})
export class FinishPointDialogComponent implements OnInit {

  nameControl: FormControl<string> = new FormControl<string>('', {
    validators: [Validators.required, Validators.maxLength(20)],
    nonNullable: true,
  });
  addressControl: FormControl<string> = new FormControl<string>('', {
    validators: [Validators.required, Validators.maxLength(20)],
    nonNullable: true,
  });
  latitudeControl: FormControl<number | null> = new FormControl<number | null>(0, {
    validators: [Validators.min(-90), Validators.max(90)],
    nonNullable: false,
  });
  longitudeControl: FormControl<number | null> = new FormControl<number | null>(0, {
    validators: [Validators.min(-180), Validators.max(180)],
    nonNullable: false,
  });

  static async open(dialog: MatDialog, finishPoints: FinishPoint[]): Promise<FinishPoint | null> {
    return await dialog.open(FinishPointDialogComponent, {
      width: '60vw',
      data: {
        finishPoints
      }
    }).afterClosed().toPromise();
  }

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private data: { finishPoints: FinishPoint[] },
    private dialogRef: MatDialogRef<FinishPointDialogComponent>,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
  }

  onAdd(): void {
    if (this.nameControl.hasError('required')) {
      MessageDialogComponent.createErrorDialog(this.dialog, '名称を入力してください。');
      return;
    }
    if (this.nameControl.hasError('maxLength')) {
      MessageDialogComponent.createErrorDialog(this.dialog, '名称は20文字以内で入力してください。');
      return;
    }
    const sameName = this.data.finishPoints.find(item => {
      return item.name === this.nameControl.value;
    });
    if (sameName) {
      MessageDialogComponent.createErrorDialog(this.dialog, '既に登録済みの名称です。');
      return;
    }
    if (this.addressControl.hasError('required')) {
      MessageDialogComponent.createErrorDialog(this.dialog, '地名（住所）を入力してください。');
      return;
    }
    if (this.addressControl.hasError('maxLength')) {
      MessageDialogComponent.createErrorDialog(this.dialog, '地名（住所）は20文字以内で入力してください。');
      return;
    }
    if (this.latitudeControl.hasError('min')) {
      MessageDialogComponent.createErrorDialog(this.dialog, '緯度には-90以上の値を入力してください。');
      return;
    }
    if (this.latitudeControl.hasError('max')) {
      MessageDialogComponent.createErrorDialog(this.dialog, '緯度には90以下の値を入力してください。');
      return;
    }
    if (this.longitudeControl.hasError('min')) {
      MessageDialogComponent.createErrorDialog(this.dialog, '経度には-180以上の値を入力してください。');
      return;
    }
    if (this.longitudeControl.hasError('max')) {
      MessageDialogComponent.createErrorDialog(this.dialog, '経度には180以下の値を入力してください。');
      return;
    }
    const sameLocation = this.data.finishPoints.find(item => {
      return item.latitude === this.latitudeControl.value && item.longitude === this.longitudeControl.value;
    });
    if (sameLocation) {
      MessageDialogComponent.createErrorDialog(this.dialog, '既に登録済みの緯度経度です。');
      return;
    }

    const finishPoint: FinishPoint = {
      race_id: undefined,
      name: this.nameControl.value,
      address: this.addressControl.value,
      latitude: this.latitudeControl.value!,
      longitude: this.longitudeControl.value!,
    };
    this.dialogRef.close(finishPoint);
  }

}
